export const EMOJI_PICKER_RECENT_STORAGE_KEY = "easy8.dsEmojiPicker.recentEmojis";
export const EMOJI_PICKER_RECENT_LIMIT = 24;
